const encoder = new TextEncoder();

function leftRotate(x, n) {
  const shift = n % 32;
  return (((x << shift) | (x >>> (32 - shift))) >>> 0);
}

function gt(value, length, _padChar) {
  return String(value).padStart(length, '0');
}

function normalizeRuntime(runtime = {}) {
  return {
    nowMs: typeof runtime.nowMs === 'function' ? runtime.nowMs : () => Date.now(),
    random: typeof runtime.random === 'function' ? runtime.random : () => Math.random(),
  };
}

function getArr(input, format = 'array') {
  const reg = {
    chunk: [],
    reg: [
      1937774191,
      1226093241,
      388252375,
      3666478592,
      2842636476,
      372324522,
      3817729613,
      2969243214,
    ],
    size: 0,
  };

  function compress(block) {
    if (block.length < 64) {
      return;
    }

    const temp = new Array(132).fill(0);

    for (let i = 0; i < 16; i += 1) {
      temp[i] = (
        ((block[4 * i] << 24) >>> 0)
        | (block[4 * i + 1] << 16)
        | (block[4 * i + 2] << 8)
        | block[4 * i + 3]
      ) >>> 0;
    }

    for (let i = 16; i < 68; i += 1) {
      let value = (temp[i - 16] ^ temp[i - 9] ^ leftRotate(temp[i - 3], 15)) >>> 0;
      value = (value ^ leftRotate(value, 15) ^ leftRotate(value, 23)) >>> 0;
      temp[i] = (value ^ leftRotate(temp[i - 13], 7) ^ temp[i - 6]) >>> 0;
    }

    for (let i = 0; i < 64; i += 1) {
      temp[i + 68] = (temp[i] ^ temp[i + 4]) >>> 0;
    }

    const state = reg.reg.slice();

    for (let i = 0; i < 64; i += 1) {
      let tValue;
      let ff;
      let gg;

      if (i < 16) {
        tValue = 2043430169;
        ff = (state[0] ^ state[1] ^ state[2]) >>> 0;
      } else {
        tValue = 2055708042;
        ff = ((state[0] & state[1]) | (state[0] & state[2]) | (state[1] & state[2])) >>> 0;
      }

      const ss1 = leftRotate((leftRotate(state[0], 12) + state[4] + leftRotate(tValue, i)) >>> 0, 7);
      const ss2 = (ss1 ^ leftRotate(state[0], 12)) >>> 0;
      const tt1 = (ff + state[3] + ss2 + temp[i + 68]) >>> 0;

      if (i < 16) {
        gg = (state[4] ^ state[5] ^ state[6]) >>> 0;
      } else {
        gg = ((state[4] & state[5]) | ((~state[4]) & state[6])) >>> 0;
      }

      const tt2 = (gg + state[7] + ss1 + temp[i]) >>> 0;

      state[3] = state[2];
      state[2] = leftRotate(state[1], 9);
      state[1] = state[0];
      state[0] = tt1;
      state[7] = state[6];
      state[6] = leftRotate(state[5], 19);
      state[5] = state[4];
      state[4] = (tt2 ^ leftRotate(tt2, 9) ^ leftRotate(tt2, 17)) >>> 0;
    }

    for (let i = 0; i < 8; i += 1) {
      reg.reg[i] = (reg.reg[i] ^ state[i]) >>> 0;
    }
  }

  function write(value) {
    const bytes = typeof value === 'string'
      ? Array.from(encoder.encode(value))
      : Array.from(value);

    reg.size += bytes.length;
    let index = 64 - reg.chunk.length;

    if (bytes.length < index) {
      reg.chunk.push(...bytes);
      return;
    }

    reg.chunk.push(...bytes.slice(0, index));
    while (reg.chunk.length >= 64) {
      compress(reg.chunk.slice(0, 64));
      if (index < bytes.length) {
        reg.chunk = bytes.slice(index, Math.min(index + 64, bytes.length));
      } else {
        reg.chunk = [];
      }
      index += 64;
    }
  }

  function fill() {
    const bitLength = BigInt(reg.size) * 8n;
    reg.chunk.push(128);
    let index = reg.chunk.length % 64;

    if (64 - index < 8) {
      index -= 64;
    }

    while (index < 56) {
      reg.chunk.push(0);
      index += 1;
    }

    const high = Number(bitLength / 4294967296n);
    for (let i = 0; i < 4; i += 1) {
      reg.chunk.push((high >> (8 * (3 - i))) & 255);
    }

    const low = Number(bitLength & 4294967295n);
    for (let i = 0; i < 4; i += 1) {
      reg.chunk.push((low >> (8 * (3 - i))) & 255);
    }
  }

  write(input);
  fill();

  for (let i = 0; i < reg.chunk.length; i += 64) {
    compress(reg.chunk.slice(i, i + 64));
  }

  if (format === 'hex') {
    let result = '';
    for (let i = 0; i < 8; i += 1) {
      result += gt(reg.reg[i].toString(16), 8, '0');
    }
    return result;
  }

  const result = new Array(32).fill(0);
  for (let i = 0; i < 8; i += 1) {
    let value = reg.reg[i];
    result[4 * i + 3] = value & 255;
    value >>>= 8;
    result[4 * i + 2] = value & 255;
    value >>>= 8;
    result[4 * i + 1] = value & 255;
    value >>>= 8;
    result[4 * i] = value & 255;
  }
  return result;
}

function encodeCustomBase64(input, alphabet) {
  let result = '';
  let j = 0;

  for (let i = 0; i < input.length + 1; i += 3) {
    if (i + 3 <= input.length) {
      const charCode0 = input.charCodeAt(i);
      const charCode1 = input.charCodeAt(i + 1);
      const charCode2 = input.charCodeAt(i + 2);
      const baseNum = (charCode2 | (charCode1 << 8) | (charCode0 << 16)) >>> 0;

      result += alphabet[(baseNum & 16515072) >> 18];
      result += alphabet[(baseNum & 258048) >> 12];
      result += alphabet[(baseNum & 4032) >> 6];
      result += alphabet[baseNum & 63];
    }

    if (i + 3 > input.length) {
      const remaining = input.length - j;
      if (remaining === 2) {
        const charCode0 = input.charCodeAt(j);
        const charCode1 = input.charCodeAt(j + 1);
        const baseNum = ((charCode1 << 8) | (charCode0 << 16)) >>> 0;
        result += alphabet[(baseNum & 16515072) >> 18];
        result += alphabet[(baseNum & 258048) >> 12];
        result += alphabet[(baseNum & 4032) >> 6];
        result += '=';
      } else if (remaining === 1) {
        const charCode0 = input.charCodeAt(j);
        const baseNum = (charCode0 << 16) >>> 0;
        result += alphabet[(baseNum & 16515072) >> 18];
        result += alphabet[(baseNum & 258048) >> 12];
        result += '==';
      }
    }

    j += 3;
  }

  return result;
}

function abArr256() {
  const nums = Array.from({ length: 256 }, (_, index) => 255 - index);
  let previousValue = 0;
  const lm = 211;

  for (let i = 0; i < nums.length; i += 1) {
    const num1 = previousValue * nums[i];
    previousValue = (num1 + previousValue + lm) % 256;
    [nums[i], nums[previousValue]] = [nums[previousValue], nums[i]];
  }

  return nums;
}

function abGarbledCharacters(value) {
  const arr256 = abArr256();
  let n4 = 0;
  let result = '';

  for (let i = 0; i < value.length; i += 1) {
    const n2 = (i + 1) % 256;
    const n3 = n4 + arr256[n2];
    n4 = n3 % 256;
    const oldArrN2 = arr256[n2];
    arr256[n2] = arr256[n4];
    arr256[n4] = oldArrN2;
    const n5 = value.charCodeAt(i);
    const n6 = arr256[n2] + oldArrN2;
    const n7 = n6 % 256;
    const n8 = n5 ^ arr256[n7];
    result += String.fromCharCode(n8);
  }

  return result;
}

function uaArr256(userAgent, uaSalt) {
  const nums = Array.from({ length: 256 }, (_, index) => 255 - index);
  let previousValue = 0;
  const lm = [0, 1, uaSalt];

  for (let i = 0; i < nums.length; i += 1) {
    const num1 = previousValue * nums[i];
    previousValue = (num1 + previousValue + lm[i % 3]) % 256;
    [nums[i], nums[previousValue]] = [nums[previousValue], nums[i]];
  }

  return nums;
}

function uaGarbledCharacters(userAgent, uaSalt) {
  const arr256 = uaArr256(userAgent, uaSalt);
  let n4 = 0;
  let result = '';

  for (let i = 0; i < userAgent.length; i += 1) {
    const n2 = (i + 1) % 256;
    const n3 = n4 + arr256[n2];
    n4 = n3 % 256;
    const oldArrN2 = arr256[n2];
    arr256[n2] = arr256[n4];
    arr256[n4] = oldArrN2;
    const n5 = userAgent.charCodeAt(i);
    const n6 = arr256[n2] + oldArrN2;
    const n7 = n6 % 256;
    const n8 = n5 ^ arr256[n7];
    result += String.fromCharCode(n8);
  }

  return result;
}

function encryptionUa(value) {
  const chars = 'ckdp1h4ZKsUB80/Mfvw36XIgR25+WQAlEi7NLboqYTOPuzmFjJnryx9HVGDaStCe';
  return encodeCustomBase64(value, chars);
}

function getArr2(userAgent) {
  const data = userAgent.includes('Win')
    ? '1280|585|1280|672|1280|672|1280|720|Win32'
    : '2056|1080|2056|1201|2056|1201|2056|1329|MacIntel';

  return Array.from(data, (char) => char.charCodeAt(0));
}

function getLast3Num(dateTime1) {
  const timestamp = `${(Math.trunc(dateTime1) + 3) & 255},`;
  return Array.from(timestamp, (char) => char.charCodeAt(0));
}

function getLastNum2(arr1, arr) {
  const arrIndexes = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
    20, 21, 22, 23, 25, 26, 27, 29, 30, 31, 33, 34, 35, 36, 37, 38, 39, 40,
    41, 42, 43, 44, 45, 46, 47, 48, 50, 51, 53, 54,
  ];

  let xorResult = 0;
  for (let i = 0; i < arr1.length; i += 1) {
    xorResult ^= arr1[i];
  }
  for (const index of arrIndexes) {
    xorResult ^= arr[index];
  }
  return xorResult;
}

function getNumList(arr0, arrAr, runtime) {
  const numList = [];

  for (let i = 0; i < arrAr.length; i += 3) {
    if (i + 2 >= arrAr.length) {
      if (i + 1 >= arrAr.length) {
        numList.push(arrAr[i]);
      } else {
        numList.push(arrAr[i], arrAr[i + 1]);
      }
      continue;
    }

    const randomValue = Math.trunc(runtime.random() * 1000) & 255;
    const num1 = (randomValue & 145) | (arrAr[i] & 110);
    const num2 = (randomValue & 66) | (arrAr[i + 1] & 189);
    const num3 = (randomValue & 44) | (arrAr[i + 2] & 211);
    const num4 = ((arrAr[i] & 145) | (arrAr[i + 1] & 66) | (arrAr[i + 2] & 44)) >>> 0;
    numList.push(num1, num2, num3, num4);
  }

  return arr0.concat(numList);
}

function topHeaderRandomGarbledCharacters(runtime) {
  const arr = [];
  const randomValue = runtime.random() * 65535;
  const num1 = Math.trunc(randomValue) & 255;
  const num2 = Math.trunc(runtime.random() * 40);

  arr.push((num1 & 170) | (3 & 85));
  arr.push((num1 & 85) | (3 & 170));
  arr.push((num2 & 170) | (82 & 85));
  arr.push((num2 & 85) | (82 & 170));

  return String.fromCharCode(...arr);
}

function randomGarbledCharactersArrayList(runtime) {
  function randomGarbledCharactersArray1() {
    const arr = [];
    const randomValue = runtime.random() * 65535;
    const num1 = Math.trunc(randomValue) & 255;
    const num2 = (Math.trunc(randomValue) >> 8) & 255;

    arr.push((num1 & 170) | (1 & 85));
    arr.push((num1 & 85) | (1 & 170));
    arr.push((num2 & 170) | (0 & 85));
    arr.push((num2 & 85) | (0 & 170));
    return arr;
  }

  function randomGarbledCharactersArray2() {
    const arr = [];
    const num1 = Math.trunc(runtime.random() * 240);
    const num2 = ((Math.trunc(runtime.random() * 255)) & 77) | 2 | 16 | 32 | 128;

    arr.push((num1 & 170) | (1 & 85));
    arr.push((num1 & 85) | (1 & 170));
    arr.push((num2 & 170) | (0 & 85));
    arr.push((num2 & 85) | (0 & 170));
    return arr;
  }

  return randomGarbledCharactersArray1().concat(randomGarbledCharactersArray2());
}

function getArr29(dateTime1, dateTime2, params, data, userAgent, runtime) {
  const parArr = getArr(getArr(params));
  const dataArr = getArr(getArr(data));
  const uaSalt = userAgent.includes('Win') ? 0 : 14;
  const browserArr = getArr(encryptionUa(uaGarbledCharacters(userAgent, uaSalt)));
  const arr = new Array(55).fill(0);
  const arr2 = new Array(50).fill(0);
  const num = getArr2(userAgent);
  const dateTime3 = Math.trunc((runtime.nowMs() - 1721836800000) / 1000 / 60 / 60 / 24 / 14);
  const arr0 = randomGarbledCharactersArrayList(runtime);

  arr[0] = 41;
  arr[1] = dateTime3;
  arr[2] = 5;
  arr[3] = (Math.trunc(dateTime1) - Math.trunc(dateTime2) + 3) & 255;
  arr[4] = dateTime1 & 255;
  arr[5] = (dateTime1 >> 8) & 255;
  arr[6] = (dateTime1 >> 16) & 255;
  arr[7] = (dateTime1 >> 24) & 255;
  arr[8] = Math.floor(dateTime1 / 256 ** 4) & 255;
  arr[9] = Math.floor(dateTime1 / 256 ** 5) & 255;
  arr[10] = 1 & 255;
  arr[11] = (1 / 256) & 255;
  arr[12] = 1 & 255;
  arr[13] = (1 >> 8) & 255;
  arr[14] = 1;
  arr[15] = 0 & 255;
  arr[16] = 0 & 255;
  arr[17] = 0 & 255;
  arr[18] = uaSalt & 255;
  arr[19] = (uaSalt >> 8) & 255;
  arr[20] = (uaSalt >> 16) & 255;
  arr[21] = (uaSalt >> 24) & 255;
  arr[22] = parArr[9];
  arr[23] = parArr[18];
  arr[24] = 3;
  arr[25] = parArr[3];
  arr[26] = dataArr[10];
  arr[27] = dataArr[19];
  arr[28] = 4;
  arr[29] = dataArr[4];
  arr[30] = browserArr[11];
  arr[31] = browserArr[21];
  arr[32] = 5;
  arr[33] = browserArr[5];
  arr[34] = dateTime2 & 255;
  arr[35] = (dateTime2 >> 8) & 255;
  arr[36] = (dateTime2 >> 16) & 255;
  arr[37] = (dateTime2 >> 24) & 255;
  arr[38] = Math.floor(dateTime2 / 256 ** 4) & 255;
  arr[39] = Math.floor(dateTime2 / 256 ** 5) & 255;
  arr[40] = 3;

  const arr32 = 6241;
  arr[41] = arr32 & 255;
  arr[42] = (arr32 >> 8) & 255;
  arr[43] = (arr32 >> 16) & 255;
  arr[44] = (arr32 >> 24) & 255;

  const arr36 = 6383;
  arr[45] = arr36 & 255;
  arr[46] = (arr36 >> 8) & 255;
  arr[47] = (arr36 >> 16) & 255;
  arr[48] = (arr36 >> 24) & 255;

  const lastNumOne = getLast3Num(dateTime1);
  arr[49] = num.length;
  arr[50] = num.length & 255;
  arr[51] = (num.length >> 8) & 255;
  arr[52] = lastNumOne.length;
  arr[53] = lastNumOne.length & 255;
  arr[54] = (lastNumOne.length >> 8) & 255;

  const lastNum = getLastNum2(arr0, arr);

  arr2[0] = arr[9];
  arr2[1] = arr[18];
  arr2[2] = arr[30];
  arr2[3] = arr[35];
  arr2[4] = arr[47];
  arr2[5] = arr[4];
  arr2[6] = arr[44];
  arr2[7] = arr[19];
  arr2[8] = arr[10];
  arr2[9] = arr[23];
  arr2[10] = arr[12];
  arr2[11] = arr[40];
  arr2[12] = arr[25];
  arr2[13] = arr[42];
  arr2[14] = arr[3];
  arr2[15] = arr[22];
  arr2[16] = arr[38];
  arr2[17] = arr[21];
  arr2[18] = arr[5];
  arr2[19] = arr[45];
  arr2[20] = arr[1];
  arr2[21] = arr[29];
  arr2[22] = arr[6];
  arr2[23] = arr[43];
  arr2[24] = arr[33];
  arr2[25] = arr[14];
  arr2[26] = arr[36];
  arr2[27] = arr[37];
  arr2[28] = arr[2];
  arr2[29] = arr[46];
  arr2[30] = arr[15];
  arr2[31] = arr[48];
  arr2[32] = arr[31];
  arr2[33] = arr[26];
  arr2[34] = arr[16];
  arr2[35] = arr[13];
  arr2[36] = arr[8];
  arr2[37] = arr[41];
  arr2[38] = arr[27];
  arr2[39] = arr[17];
  arr2[40] = arr[39];
  arr2[41] = arr[20];
  arr2[42] = arr[11];
  arr2[43] = arr[0];
  arr2[44] = arr[34];
  arr2[45] = arr[7];
  arr2[46] = arr[50];
  arr2[47] = arr[51];
  arr2[48] = arr[53];
  arr2[49] = arr[54];

  const newArr = arr2.concat(num);
  const newArr2 = newArr.concat(lastNumOne);
  newArr2.push(lastNum);

  return getNumList(arr0, newArr2, runtime);
}

function getGarbledString(params, data, userAgent, runtimeOptions) {
  const runtime = normalizeRuntime(runtimeOptions);
  const timestamp1 = Math.trunc(runtime.nowMs());
  const timestamp2 = timestamp1 - Math.floor(runtime.random() * 10);
  const arr29 = getArr29(timestamp1, timestamp2, params, data, userAgent, runtime);
  const prefix = topHeaderRandomGarbledCharacters(runtime);
  const mixed = abGarbledCharacters(String.fromCharCode(...arr29));
  return prefix + mixed;
}

function getABogus(url, data, userAgent, runtimeOptions) {
  const safeUrl = String(url);
  const safeData = String(data);
  const safeUserAgent = String(userAgent);
  const params = safeUrl.slice(safeUrl.indexOf('?') + 1) + 'dhzx';
  const mixedData = safeData + 'dhzx';
  const garbledString = getGarbledString(params, mixedData, safeUserAgent, runtimeOptions);
  const alphabet = 'Dkdpgh2ZmsQB80/MfvV36XI1R45-WUAlEixNLwoqYTOPuzKFjJnry79HbGcaStCe';

  return encodeCustomBase64(garbledString, alphabet);
}

module.exports = {
  leftRotate,
  left_rotate: leftRotate,
  gt,
  getArr,
  get_arr: getArr,
  getABogus,
  getGarbledString,
  abGarbledCharacters,
  abArr256,
  ab_arr_256: abArr256,
  getArr29,
  get_arr29: getArr29,
  getLast3Num,
  getLast_3Num: getLast3Num,
  getArr2,
  get_arr2: getArr2,
  getLastNum2,
  getNumList,
  topHeaderRandomGarbledCharacters,
  randomGarbledCharactersArrayList,
  encryptionUa,
  uaGarbledCharacters,
  uaArr256,
  ua_arr_256: uaArr256,
};
